import React from 'react';
import { Provider } from 'react-redux';
import configureStore from './store/configure-store';
import './App.css';
import Router from './containers/Router';

const store = configureStore();

const App = () => (
  <Provider store={store}>
    <Router />
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx